<template>
  <div>
    <div class="left_tree">

      <vxe-button @click="addGroup" style="margin:0 0 10px 0">新增分组</vxe-button>
      <vxe-button @click="updateGroup" style="margin:0 7px 10px">修改分组</vxe-button>
      <vxe-button @click="deleteGroup" style="margin:0 0 10px 0">删除分组</vxe-button>

      <a-tree
          :show-icon="true"
          :checkStrictly="true"
          :defaultExpandAll="false"
          :defaultExpandParent="true"
          :expandedKeys.sync="defaultExpandedKeys"
          :tree-data="tagList"
          :selectedKeys="selectedKeys"
          :replaceFields="{children:'children', title:'groupName', key:'groupId', value: 'groupId' }"
          @select="onSelect"
          @check="onCheck"
      >
        <!--          :checkable="true"-->
        <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
        <a-icon type="cluster" slot="region" style="color:#52c41a"/>
      </a-tree>

    </div>
    <div class="right_table">
<!--      <div class="tips_words" v-if="isQWLabel">-->
<!--        企业标签由企业统一配置，配置后，企业成员可以对好友打企业标签。-->
<!--      </div>-->
<!--      <div class="tips_words" v-if="!isQWLabel">-->
<!--        SCRM标签由系统根据客户对营销素材感兴趣程度、渠道来源等结合配置规则，自动打标签。-->
<!--      </div>-->
      <x-grid style="height: 83vh;overflow-y: auto"
              :id="'formList'"
              :rowId="rowId"
              :pager-config="pagerConfig"
              :form-config="formConfig"
              :url="url"
              :columns="columns"
              :checkbox-config="checkboxConfig"
              :toolbar-config="toolbarConfig"
              :print-config="printConfig"
              :export-config="exportConfig"
              :other-params='otherParams'
              ref="grid"
              :cellClick="chooseRow"
              :cellDbClick="updateRow"
              @toolbar-addData="addRow"
              @toolbar-delData="delRow('删除后，已添加到客户信息的标签也一起删除')"
      >
<!--        <template v-slot:[toolbarConfig.templatelSlots]>-->
<!--          <vxe-button @click="synchronization()">同步</vxe-button>-->
<!--        </template>-->
      </x-grid>

      <!-- 标签新增 -->
      <a-modal
          title="标签详情"
          centered
          :closable="false"
          :footer="null"
          :maskClosable="false"
          :visible="editModalVisible"
          :width="500"
      >
        <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
        <detailForm
            :rowId="editRowId"
            v-if="editModalVisible"
            :selectedObj="selectedObj"
            ref="form"
            @cancelled="closeEdit()"
            @saved="closeEdit(true)"
        >
        </detailForm>
      </a-modal>

      <!-- 分组新增 -->
      <a-modal
          title="标签分组详情"
          centered
          :closable="false"
          :footer="null"
          :maskClosable="false"
          :visible="labelGroupVisible"
          :width="500"
      >
        <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
        <detailGroupForm
            :parentId="parentId"
            :groupId="groupId"
            :tagTypeName="tagTypeName"
            :readyTodo="readyTodo"
            :selectedObj="selectedObj"
            v-if="labelGroupVisible"
            ref="form"
            @cancelled="closeLabelGroup"
            @reload="getTagList"
        >
        </detailGroupForm>
      </a-modal>


    </div>
  </div>

</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除

import detailForm from "@/pages/web/client/labelManage/labelManageDetail";
import detailGroupForm from "@/pages/web/client/labelManage/labelManageGroupDetail";

//弹出层组件
import {dataApi} from "@/services/client/labelManage";
import {XEUtils} from "@/utils/common/FormBase";

const fac = XGrid.factory;

//列表接口
let url = api.client.LABEL;

//主键
const rowId = "tagId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("tagName", "标签名称", 'auto', 'center'),
  fac.makeColumn("tagTypeName", "标签类型", 'auto', 'center'),
  fac.makeColumn("tagGroupName", "标签分组", 'auto', 'center'),
  fac.makeColumn("userName", "创建人", 'auto', "center"),
  // fac.makeColumn("createDate", "创建时间", 'auto', "center"),
  // fac.makeColumn("lastModifyName", "最后修改人", 'auto', "center"),
  // fac.makeColumn("lastModifyDate", "最后修改时间", 'auto', "center"),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "tagName"},
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: true,
  addData: true,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm,
    detailGroupForm,
  },
  async mounted() {
    this.getTagList().then();
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: [],
      tagList: [],
      defaultExpandedKeys: [],
      selectedKeys: [],
      allList: [],
      groupId: 0,
      parentId: 0,
      labelGroupVisible: false,
      otherParams: {},
      tagTypeName: '',
      readyTodo: false,
      selectedObj: {},
      isQWLabel: true
    };
  },
  methods: {
    // 新增分组
    addGroup() {
      this.readyTodo = false;
      if (!this.groupId) {
        this.$message.error('请选择要添加分组的类型');
      } else if (!this.parentId) {
        if (this.groupId == 1) {
          this.$message.error('企微标签不能手动添加分组');
        } else {
          this.labelGroupVisible = true;
        }
      } else {
        this.$message.error('二级标签不能添加分组');
      }
    },
    closeLabelGroup() {
      this.labelGroupVisible = false;
    },
    // 修改分组
    updateGroup() {
      this.readyTodo = true;
      if (!this.groupId) {
        this.$message.error('请选择要更新的分组');
      } else if (!this.parentId) {
        this.$message.error('一级标签不能更新');
      } else {
        this.labelGroupVisible = true;
      }
    },
    // 删除分组
    async deleteGroup() {
      console.log('删除分组')
      if (!this.groupId) {
        this.$message.error('请选择要删除的分组');
      } else if (!this.parentId) {
        this.$message.error('一级标签不能删除');
      } else {
        this.loading(true);
        let entity = await dataApi.deleteGroup(this.groupId); //删除
        if (entity.code === 200) {
          this.$message.success('删除成功');
          this.getTagList();
          this.loading(false);
          this.refresh();
        } else if (entity.code === 201) {
          this.$message.warn(entity.data);
        }
        this.loading(false);
        this.refresh();
      }
    },
    // 获取标签树的数据
    async getTagList() {
      let tagList = await dataApi.getTagList();
      this.allList = tagList.data;
      this.tagList = XEUtils.toArrayTree(tagList.data, {
        key: 'groupId',
        parentKey: 'parentId',
        children: 'children'
      })
      if (tagList.data.length) {
        this.defaultExpandedKeys = tagList.data.map(val => {
          // //默认只展开一级
          // if (val.groupId == 1) { //已确定测试、正式系统最大一层tagId都是1
          //   return val.groupId
          // }
          return val.groupId
        })
      }
    },
    /**
     * 选中树
     * @param selectedKeys
     */
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
      this.groupId = selectedKeys[0];
      let idx = this.allList.findIndex(item => {
        return item.groupId === this.groupId;
      })
      this.otherParams = {
        'filter.eq.tagGroupId': this.groupId
      }
      this.parentId = this.allList[idx].parentId;
      this.tagTypeName = this.allList[idx].groupName;
      this.selectedObj = this.allList[idx];
      // 标签提示语
      if (this.selectedObj.groupName === "SCRM标签" || this.selectedObj.parentName === "SCRM标签") {
        this.isQWLabel = false;
      } else {
        this.isQWLabel = true;
      }
      this.$nextTick(() => {
        this.refresh()
      })
    },
    /**
     * 选择复选框
     * @param checkedKeys
     */
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys.checked;
    },
    // 同步
    async synchronization() {
      this.loading(true);
      await dataApi.synchronization().then(res => {
        this.$message.success(res.msg ? res.msg : '同步成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      window.location.reload();
      // this.refresh();
    },
  },
};
</script>

<style scoped lang="less">
.left_tree {
  width: 20%;
  padding: 20px;
  float: left;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow: hidden;
}

.right_table {
  width: 80%;
  float: right;
  height: 100%;
}

.tips_words {
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  font-size: 14px;
  padding: 0 0 0 26px;
}

</style>
